// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
export type ReviewCardReviewFragment = {
  __typename?: 'Review';
  id: string;
  rate: number;
  overallRate: number;
  comment?: string | null;
  guestReviewer?: string | null;
  anonymous: boolean;
  reviewedAt: number;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  } | null;
};

export const ReviewCardReviewFragmentDoc = gql`
  fragment ReviewCard_Review on Review {
    id
    applicant {
      id
      user {
        id
        firstName
        lastName
        pictureLink
      }
    }
    rate
    overallRate
    comment
    guestReviewer
    anonymous
    reviewedAt
  }
`;
